/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, OnInit } from '@angular/core';
import {ReportContentDetailComponent} from './report-content-detail.component';
import {LoggerService} from '../../../shared/services/logger.service';
import {Store} from '@ngxs/store';
import {IsolatedReportService} from '../../services/isolatedReport.service';
import {GoogleMapService} from '../../../map/services/googleMap.service';

@Component({
  selector: 'dash-gis-report-content-print-detail',
  templateUrl: './report-content-print-detail.component.html',
  styleUrls: ['./report-content-print-detail.component.scss']
})
export class ReportContentPrintDetailComponent extends ReportContentDetailComponent {

  constructor(
      logger: LoggerService,
      isolatedReportService: IsolatedReportService,
      googleMapService: GoogleMapService,
      store: Store,
  ) {
      super(
          logger,
          isolatedReportService,
          googleMapService,
          store,
      );
  }
}
